<template>
  <div class>
    <STable
      ref="tableref"
      :url="url"
      :columns="columns"
      :query="query"
      :selection="false"
      :isPlant="false"
      labelWidth="120px"
      @cascaderChange="cascaderChange"
    ></STable>
  </div>
</template>

<script>
import fieldFilter from "@/utils/fieldFilter.js";
export default {
  name: "notifiAlarmRecord",
  components: {},
  data() {
    return {
      url: "/battery/dcNoticeRecord/page",
      brandData:[],
      columns: [
        {
          label: "设备名称",
          prop: "deviceName",
        },
        {
          label: "项目名称",
          prop: "projectName",
        },
        {
          label: "企业名称",
          prop: "companyName",
        },
        {
          label: "品牌",
          prop: "brandName",
        },
        {
          label: "型号",
          prop: "modelName",
        },
        {
          label: "告警原因",
          prop: "reason",
        },
        {
          label: "告警时间",
          prop: "alarmTime",
        },
        {
          label: "通知时间",
          prop: "noticeTime",
        },
        {
          label: "通知接收人",
          prop: "mobiles",
          type: "popover"
        },
        {
          label: "通知方式",
          prop: "noticeType",
        }
      ],

      query: [
        {
          label: "设备名称",
          prop: "deviceName",
          placeholder: "请输入设备名称",
        },
        {
          label: "品牌型号",
          prop: "brandName",
          type: "cascadersingle",
          data: this.brandData,
          props: { value: "id", label: "name" },
          placeholder: "请选择品牌型号",
        },
        {
          label: "项目名称",
          prop: "projectName",
          placeholder: "请输入项目名称",
        },
        {
          label: "企业名称",
          prop: "companyName",
          placeholder: "请输入企业名称",
        },
        // {
        //   label: "告警原因",
        //   prop: "reason",
        //   type: "select",
        //   data: [
        //       {label:"请选择告警原因",value:""},
        //       {label:"枪线温度告警",value:""},
        //       {label:"充电电压告警",value:""},
        //       {label:"充电电流告警",value:""},
        //       {label:"输出功率不足告警",value:""},
        //       {label:"电桩离线告警",value:""},
        //       {label:"电桩故障告警",value:""},
        //       {label:"SOC过充告警",value:""},
        //       {label:"电池电量过充告警",value:""},
        //       {label:"电池温度过高告警",value:""},
        //       {label:"用户账户负值告警",value:""}
        //   ],
        //   placeholder: "请选择告警原因",
        // },
        {
          label: "通知方式",
          prop: "noticeType",
          placeholder: "请选择通知方式",
          type: "select",
          data: [{label:"短信",value:"短信"}]
        },
        {
          label: "通知时间",
          prop: "noticeTime",
          type: "date2",
          placeholder: "",
          option: {
            type: "datetimerange"
          }
        },
        {
          label: "告警时间",
          prop: "alarmTime",
          type: "date2",
          placeholder: "",
          option: {
            type: "datetimerange"
          }
        }
      ]
    };
  },
  computed: {},
  methods: {
    getBrandDataInfo() {
      this.$store.dispatch("form/handle", {
        url: "/battery/tree/brandModel",
        data: {},
        method: "get",
        callback: (resp) => {
          this.brandData = resp;
          this.getTreeData();
        },
      });
    },
    getTreeData() {
      for (var i = 0; i < this.brandData.length; i++) {
        if (this.brandData[i].children.length == 0) {
          // children若为空数组，则将children删除
          delete this.brandData[i].children;
        } else {
          for (var k = 0; k < this.brandData[i].children.length; k++) {
            if (this.brandData[i].children[k].children.length == 0) {
              // children若为空数组，则将children删除
              delete this.brandData[i].children[k].children;
            } else  {
              for (var h = 0; h < this.brandData[i].children[k].children.length; h++) {
                if (this.brandData[i].children[k].children[h].children.length == 0) {
                  // children若为空数组，则将children删除
                  delete this.brandData[i].children[k].children[h].children;
                }
              }
            }
          }
        }
      }
      this.$refs.tableref.query[1].data = this.brandData;
    },
    cascaderChange(param) {
      this.brandData.forEach(element=>{
        if(element.id==param.param[0]) {
          this.$refs.tableref.queryForm.brandName = element.name;
        }
        element.children.forEach(subElement=>{
          if(subElement.id==param.param[1]) {
            this.$refs.tableref.queryForm.modelName = subElement.name;
          }
        });
      });
    },
  },
  mounted() {

  },
  created() {
    this.getBrandDataInfo();
  },
  beforeCreate() {
    this.brandData = [];
  }, //生命周期 - 创建之前
  beforeMount() {}, //生命周期 - 挂载之前
  beforeUpdate() {}, //生命周期 - 更新之前
  updated() {}, //生命周期 - 更新之后
  beforeDestroy() {}, //生命周期 - 销毁之前
  destroyed() {}, //生命周期 - 销毁完成
  activated() {}, //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>

<style lang="less" src="" scoped>
</style>



// WEBPACK FOOTER //
// src/views/BMS/alarmManagement/notifiAlarmRecord/notifiAlarmRecord.vue